import { Link } from "react-router-dom";

/** ThreadList wordmark. A single hairline "thread" runs under the name. */
export const Brand = ({ to = "/", size = "md", className = "", testid = "brand-logo" }) => {
  const text = size === "lg" ? "text-[26px]" : size === "sm" ? "text-[17px]" : "text-[20px]";
  return (
    <Link to={to} className={`group inline-flex flex-col leading-none select-none ${className}`} data-testid={testid} aria-label="ThreadList">
      <span className={`font-display font-extrabold tracking-[-0.045em] ${text}`}>ThreadList</span>
      <span className="mt-[3px] block h-px w-full bg-foreground origin-left scale-x-100 transition-transform duration-300 ease-spring group-hover:scale-x-[0.55]" />
    </Link>
  );
};

export const Wordmark = ({ className = "" }) => (
  <span className={`font-display font-extrabold tracking-[-0.045em] ${className}`}>ThreadList</span>
);
